/**
 * Analytics tracker for Login module
 * Matches iOS LoginTracker.swift exactly
 */

import AnalyticsManager from '../AnalyticsManager'
import { ScreenName, ButtonName, ButtonLocation } from '../ScreenName'
import { AnalyticsEvent } from '../AnalyticsEvents'
import { AnalyticsParameters } from '../AnalyticsParameters'

type LoginMethod = 'mobile' | 'email'

/**
 * Protocol/interface for LoginTracker
 * Matches iOS LoginTrackerProtocol
 */
export interface LoginTrackerProtocol {
  trackOpenScreen(): void
  trackValidationError(endPoint: string, error: string): void
  trackSendOtpButtonTapped(loginMethod: LoginMethod): void
  trackLoginStarted(loginMethod: LoginMethod): void
  trackLoginMethodSelected(loginMethod: LoginMethod): void
}

/**
 * Login tracker implementation
 */
class LoginTracker implements LoginTrackerProtocol {
  private analyticsManager: AnalyticsManager

  constructor(analyticsManager: AnalyticsManager = AnalyticsManager.shared) {
    this.analyticsManager = analyticsManager
  }

  trackOpenScreen(): void {
    this.analyticsManager.trackScreenView(ScreenName.LOGIN)
  }

  trackValidationError(endPoint: string, error: string): void {
    this.analyticsManager.trackValidationError(ScreenName.LOGIN, undefined, error, {
      api_endpoint: endPoint,
    })
  }

  trackSendOtpButtonTapped(loginMethod: LoginMethod): void {
    this.analyticsManager.trackButtonClick(ButtonName.MOBILE_LOGIN, ButtonLocation.PRIMARY, ScreenName.LOGIN, {
      [AnalyticsParameters.loginMethod]: loginMethod,
    })
  }

  trackVerifyOtpStarted(loginMethod: LoginMethod): void {
    this.analyticsManager.trackEvent(AnalyticsEvent.VERIFY_OTP_START, ScreenName.LOGIN, {
      [AnalyticsParameters.loginMethod]: loginMethod,
    })
  }

  trackLoginStarted(loginMethod: LoginMethod): void {
    this.analyticsManager.trackEvent(AnalyticsEvent.LOGIN_STARTED, ScreenName.LOGIN, {
      [AnalyticsParameters.loginMethod]: loginMethod,
    })
  }

  trackLoginMethodSelected(loginMethod: LoginMethod): void {
    this.analyticsManager.trackEvent(AnalyticsEvent.LOGIN_METHOD_SELECTED, ScreenName.LOGIN, {
      [AnalyticsParameters.loginMethod]: loginMethod,
    })
  }
}

export default LoginTracker

